export default __webpack_public_path__ + "static/media/portraitImg.6448343e.png";